import GenericRequest, { METHOD_POST } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export class PresenceWorkerSearchTask extends GenericRequest {

    _request; // WorkerRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.WORKERS);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/webservices/presence-worker-search/PresenceWorkerSearchTask.js